import { Injectable } from '@angular/core';
import {HttpClientService} from "./http-client.service";
import {HttpParams} from "@angular/common/http";

@Injectable({
  providedIn: 'root'
})
export class AutotestService {

  constructor(private http: HttpClientService) { }

  public getLastByIdProyecto(idProyecto: string) {
    let params = new HttpParams().set("idProyecto",idProyecto);
    return this.http.getWithParams('/autotest/getlastbyidproyecto', params);
  }

  public getAutotestProyectoByIdProyecto(idProyecto: string) {
    let params = new HttpParams().set("idProyecto",idProyecto);
    return this.http.getWithParams('/autotest/getautotestproyectobyidproyecto', params);
  }

  public startNewAutotest(idProyecto: string) {
    return this.http.postResponseJSON('/autotest/startbyidproyecto', idProyecto);
  }

  public cancelAutotest(idAutotest: string) {
    let params = new HttpParams().set("idAutotest", idAutotest);
    return this.http.deleteWithParams('/autotest/cancelbyidautotest', params);
  }
}
